import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import MarcaVeiculoService from "service/gestao/frotas/MarcaVeiculoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const marcaVeiculoService = new MarcaVeiculoService();

export default function MarcaVeiculoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Marcas');

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={marcaVeiculoService} urlService="/marcaVeiculo" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="marcaVeiculo" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}